import { HTMLTable } from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalcVar } from "../../model";
import { NotaVarStore } from "../../stores/vars/NotaVarStore";

interface CalcVarLegendProps {
  vars: ICalcVar[];
}

interface CalcVarLegendState {
}

const COLORS = [
  "#2965CC",
  "#29A634",
  "#D99E0B",
  "#D13913",
  "#8F398F",
  "#00B3A4",
  "#DB2C6F",
  "#9BBF30",
  "#96622D",
  "#7157D9",
];

@observer
export class CalcVarLegend
  extends React.Component<CalcVarLegendProps, CalcVarLegendState> {
  constructor(props: CalcVarLegendProps) {
    super(props);
    NotaVarStore.load();
  }

  render() {
    let notaVars = NotaVarStore.obs.vars?.map(nv => {
      return {
        nome: nv.nome,
        descricao: nv.descricao,
        order: null,
        id: null,
        expr: null,
      };
    });

    let vars = notaVars.concat(this.props.vars)?.map(_var => {
      let color = "#000";
      if (_var.order != null) {
        let colorIdx = _var.order - 1;
        if (colorIdx > COLORS.length - 1) {
          colorIdx = (_var.order - 1) % COLORS.length;
        }
        color = COLORS[colorIdx];
      }

      return (
        <tr key={_var.nome}>
          <td className="nz-calc-var-legend-nome" style={{ color: color }}>{_var.nome}</td>
          <td style={{ textAlign: "justify", fontSize: 12 }}>{_var.descricao}</td>
        </tr>
      );
    });

    return (
      <div className="nz-calc-var-legend">
        <HTMLTable small style={{ maxWidth: 600 }}>
          <tbody>
            {vars}
          </tbody>
        </HTMLTable>
      </div>
    );
  }
}
